import React from 'react';
import { BLOCKED_DEPOSIT_MODAL_ID } from 'common/constants/profile.constants';
import { NewModal } from '../../index';
import Image from '../common.image.png';
import { S } from '../common.style';

export const BlockedDepositModalRockWest = () => {
  return (
    <NewModal ModalId={BLOCKED_DEPOSIT_MODAL_ID}>
      <img src={Image} alt="KYC" width="235" height="218" />
      <S.Bold>Deposit is not available </S.Bold>
      <S.Dimmer>please contact technical support!</S.Dimmer>
    </NewModal>
  );
};
